module.exports = __webpack_public_path__ + "static/media/Milex-Dish-Pessary-Instructions-for-Use@3x.5316cde3.jpg";